/**
 * PasswordInput Component
 * 비밀번호 입력 필드 (토글 기능 포함)
 */
import React, { useState } from "react";
import { LockIcon, EyeIcon, EyeOffIcon } from "@/shared/components/icons/Icons";

interface PasswordInputProps {
    id: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    className?: string;
    error?: string;
    label?: string;
    showLabel?: boolean;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
    id,
    name,
    value,
    onChange,
    placeholder = "비밀번호를 입력하세요",
    required = false,
    disabled = false,
    className = '',
    error,
    label = '비밀번호',
    showLabel = true
}) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className={`form-group ${className}`}>
            {showLabel && (
                <label htmlFor={id} className="form-label">
                    {label} {required && <span style={{ color: '#EF4444' }}>*</span>}
                </label>
            )}
            <div className="input-wrapper">
                <LockIcon className="input-icon" />
                <input
                    type={showPassword ? 'text' : 'password'}
                    id={id}
                    name={name}
                    className="form-input"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    required={required}
                    disabled={disabled}
                />
                <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={disabled}
                    aria-label={showPassword ? "비밀번호 숨기기" : "비밀번호 보기"}
                >
                    {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                </button>
            </div>
            {error && <div className="error-message">{error}</div>}
        </div>
    );
};

export default PasswordInput;
